import React, { useEffect, useState } from "react";
import { Col, Container, Row, Form, Tab, Tabs } from "react-bootstrap";
import style from "../form.module.scss";
import { useKPIs } from "../../../context/KPIsContext";
import { TODIS_FORM_FIELD } from "../../../components/Forms";
import "react-datepicker/dist/react-datepicker.css";
import { TODIS_BTN_SECUNDARY } from "../../../components/Buttons";
import { BsArrowClockwise } from "react-icons/bs";
import { BsExclamationCircleFill } from 'react-icons/bs';
import { loadModules } from 'esri-loader';

const SEAPORTS_NPM_KPI = ({ data, changeValues, showModalCal, filter }) => {

    const { setValues, values, sumTotal, calculoPromedioPorcentaje } = useKPIs();

    const [formValues, setFormValues] = useState({});
    const [attributes, setAttributes] = useState({});
    const [statusTabDisabled, setStatusTabDisabled] = useState(true)

    useEffect(() => {
        getRegionalPartnerGeo();
    }, [filter.objectid]);

    useEffect(() => {
        setValues(prev => {
            return data
        })
    }, [data])

    useEffect(() => {
        calculateKPI()
    }, [values])

    const calculateKPI = () => {

        const datas = {
            infrastructure: {
                upgratingReq: {
                    passenger_capacity: calculoPromedioPorcentaje('req_upgrade_inc_cap_pass', filter.yearInit),
                    freight_capacity_tn_py: calculoPromedioPorcentaje('req_upgrade_inc_cap_freight', filter.yearInit)
                },
                climateChangeResil: {
                    ch_flood_inci: "",
                    ch_closure_adv_weather_cond: ""
                }
            },
            maintenance: {
                maint_cost_total_py: sumTotal('maint_cost_total_py', filter.yearInit),
                maint_cost_landslide_py: sumTotal('maint_cost_landslide_py', filter.yearInit),
                maint_cost_maritime_py: sumTotal('maint_cost_maritime_py', filter.yearInit)
            },
            environmentalImpact: {
                co2_ems: sumTotal('co2_ems', filter.yearInit),
                nox_ems: sumTotal('nox_ems', filter.yearInit),
                so2_ems: sumTotal('so2_ems', filter.yearInit),
                nmhc_ems: sumTotal('nmhc_ems', filter.yearInit),
                ppm: sumTotal('ppm', filter.yearInit)
            }
        }

        changeValues(datas)
    }

    const getRegionalPartnerGeo = async () => {
        console.log("getRegionalPartnerGeo is called");
        try {
            const [Query, query] = await loadModules(["esri/rest/support/Query", "esri/rest/query"]);
            console.log("Modules loaded", Query, query);

            let queryUrl = "https://todis.transport-community.org/server/rest/services/Transport_services_parameters/FeatureServer/32";
            console.log("Query URL:", queryUrl);

            let queryObject = new Query();
            queryObject.where = `npm_seaports_id=${filter.objectid}`;
            queryObject.returnGeometry = false;
            queryObject.outFields = "*";

            console.log("Executing query");
            const results = await query.executeQueryJSON(queryUrl, queryObject);
            console.log("Query executed", results);

            if (results.features.length > 0) {
                const attributes = results.features[0].attributes;
                setAttributes(attributes);
                setFormValues(attributes);
                setStatusTabDisabled(false);
            } else {
                console.log("No features found with the given npmRoadId");
            }
        } catch (error) {
            console.log("Something went wrong", error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        const key = name.split('.').pop();

        // Detecta el tipo original del valor
        const originalValue = formValues[key];
        let newValue = value;

        // Convertir a número si el valor original es un número
        if (!isNaN(originalValue) && originalValue !== null && originalValue !== "") {
            newValue = Number(value);
        }

        setFormValues({
            ...formValues,
            [key]: newValue,
        });
    };


    const generateFormFields = (formValues, typeForm) => {
        const excludedFields = ["objectid", "globalid", "npm_road_id"];

        return Object.keys(formValues)
            .filter(key => !excludedFields.includes(key))
            .map(key => (
                <Col lg={6} key={key}>
                    <TODIS_FORM_FIELD
                        id={`${typeForm}.${key}`}
                        label={key.charAt(0).toUpperCase() + key.slice(1)}
                        name={`${typeForm}.${key}`}
                        disabled={true}
                        holder={formValues[key]}
                        onChange={handleChange}
                    />
                </Col>
            ));
    };

    return (
        <Tabs defaultActiveKey="Infrastructure" id="uncontrolled-tab-example" className="mb-3 todis-form-tabs-wrapper p-1 mt-3">
            <Tab eventKey="Infrastructure" title="Infrastructure" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Upgrade Requirements</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.upgratingReq.passenger_capacity" label="Percentage of Seaports requiring upgrade to increase passenger capacity" name="infrastructure.upgratingReq.passenger_capacity" disabled={true} />
                                </Col>
                                <Col lg={6}>
                                    <TODIS_FORM_FIELD id="infrastructure.upgratingReq.freight_capacity_tn_py" label="Percentage of Seaports requiring upgrade to increase freight capacity" name="infrastructure.upgratingReq.freight_capacity_tn_py" disabled={true} />
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={12}>
                            <div style={{ borderBottom: "3px solid #004494" }}>
                                <Form.Label style={{ color: '#004494', fontSize: "16px", fontWeight: "bold" }}>Climate Change Resilience</Form.Label>
                            </div>
                            <Row style={{ paddingTop: "15px" }}>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_flood_inci" label="Number of flooding incidents (% change relatively to user-defined period)" name="infrastructure.climateChangeResil.ch_flood_inci" disabled={true} />
                                </Col>
                                <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                                    <div onClick={() => showModalCal("infrastructure.climateChangeResil.ch_flood_inci", "ch_flood_inci")}>
                                        <button
                                            className="define-period-button"
                                            style={{
                                                fontSize: '10px', // Tamaño de fuente más pequeño
                                                padding: '0.25rem 0.5rem', // Padding reducido
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                backgroundColor: '#e0e7ff',
                                                border: '2px solid #000080',
                                                borderRadius: '10px', // Bordes redondeados más pequeños
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                color: '#000080',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                transition: 'background-color 0.3s, transform 0.3s'
                                            }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                            onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <span>Define</span>
                                                <span>period</span>
                                                <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                            </div>
                                        </button>
                                    </div>
                                </Col>
                                <Col lg={5}>
                                    <TODIS_FORM_FIELD id="infrastructure.climateChangeResil.ch_closure_adv_weather_cond" label="Number of closures due to adverse weather conditions (% change relatively to user-defined period)" name="infrastructure.climateChangeResil.ch_closure_adv_weather_cond" disabled={true} />
                                </Col>
                                <Col lg={1}>
                                    <TODIS_BTN_SECUNDARY variant="primary" classes="fw-bolder" style={{ fontSize: "12px", padding: "0.7rem 1rem" }} icon={BsArrowClockwise} onclick={() => showModalCal("infrastructure.climateChangeResil.ch_closure_adv_weather_cond", "ch_closure_adv_weather_cond")} />
                                </Col>
                                <Col lg={1} className="d-flex justify-content-center align-items-center my-2">
                                    <div onClick={() => showModalCal("infrastructure.climateChangeResil.ch_closure_adv_weather_cond", "ch_closure_adv_weather_cond")}>
                                        <button
                                            className="define-period-button"
                                            style={{
                                                fontSize: '10px', // Tamaño de fuente más pequeño
                                                padding: '0.25rem 0.5rem', // Padding reducido
                                                display: 'flex',
                                                flexDirection: 'column',
                                                alignItems: 'center',
                                                backgroundColor: '#e0e7ff',
                                                border: '2px solid #000080',
                                                borderRadius: '10px', // Bordes redondeados más pequeños
                                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                                color: '#000080',
                                                cursor: 'pointer',
                                                textAlign: 'center',
                                                transition: 'background-color 0.3s, transform 0.3s'
                                            }}
                                            onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#c7d2fe'}
                                            onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#e0e7ff'}
                                            onMouseDown={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
                                            onMouseUp={(e) => e.currentTarget.style.transform = 'translateY(0)'}
                                        >
                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <span>Define</span>
                                                <span>period</span>
                                                <BsArrowClockwise className="icon" style={{ marginTop: '4px', fontSize: '1rem' }} />
                                            </div>
                                        </button>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Maintenance" title="Maintenance" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_total_py" label="Maintenance cost – Total (Euro/million tons of freight)" name="maintenance.maint_cost_total_py" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_landslide_py" label="Maintenance cost - Landside Infrastructure (Euro/million tons of freight)" name="maintenance.maint_cost_landslide_py" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="maintenance.maint_cost_maritime_py" label="Maintenance cost - Maritime Infrastructure (Euro/million tons of freight)" name="maintenance.maint_cost_maritime_py" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            <Tab eventKey="Environmental" title="Environmental Impact" className={style.tabHeight}>
                <Container>
                    <Row>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.co2_ems" label="CO2 emissions (tons/ million tons of freight)" name="environmentalImpact.co2_ems" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.nox_ems" label="NOx emissions (tons/ million tons of freight)" name="environmentalImpact.nox_ems" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.so2_ems" label="SO2 emission evolution (tons/ million tons of freight)" name="environmentalImpact.so2_ems" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.nmhc_ems" label="Non-methane hydrocarbons (tons/ million tons of freight)" name="environmentalImpact.nmhc_ems" disabled={true} />
                        </Col>
                        <Col lg={6}>
                            <TODIS_FORM_FIELD id="environmentalImpact.ppm" label="Particulate matter (ppm) (tons/ million tons of freight)" name="environmentalImpact.ppm" disabled={true} />
                        </Col>
                    </Row>
                </Container>
            </Tab>
            {statusTabDisabled ? null :
                <Tab eventKey="Others" title="Others" className={style.tabHeight}>
                    <Container>
                        <Row>
                            {generateFormFields(attributes)}
                        </Row>
                    </Container>
                </Tab>
            }
        </Tabs>
    )
}

export default SEAPORTS_NPM_KPI;